import { FormulaTree } from "utils/services";
import { FormulaSelect } from "../FormulaSelect";
import { ObjectFilterByKeys } from "utils/helpers";
import FormulaLabel from "../FormulaLabel/FormulaLabel";
import { useMemo } from "react";
import { filteredObjectByValueTypes } from "../helpers/filteredObjectByValueTypes";
import { NodeRender } from "../NodeRender";
const RenderNodeList = ({
  nodeList,
  dropdownData,
  autoActiveInputs,
  setNodeCallback,
  deleteNodeCallback,
  setUpdateNodeCallback,
}) => {
  const dropdownDataToEmptyInput = useMemo(() => {
    ObjectFilterByKeys({
      object: dropdownData,
      keys: [
        FormulaTree.NODE_TYPES.Function,
        FormulaTree.NODE_TYPES.Brackets,
        FormulaTree.NODE_TYPES.Variable,
        FormulaTree.NODE_TYPES.Value,
        FormulaTree.NODE_TYPES.Constants,
      ],
    });

    return filteredObjectByValueTypes({
      object: dropdownData,
      valueTypes: ["number"],
    });
  }, [dropdownData]);

  const onSelectItem = (currentNodeId) => {
    return (item, options) => {
      setNodeCallback({
        item,
        currentNodeId,
        ...options,
      });
    };
  };

  const onUpdateItem = (currentNodeId) => {
    return (item, options) => {
      setUpdateNodeCallback({
        item,
        currentNodeId,
        ...options,
      });
    };
  };

  const onDeleteItem = (currentNodeId) => {
    deleteNodeCallback(currentNodeId)
  }

  if (nodeList?.length <= 0) {
    return (
      <FormulaSelect
        onSelectItem={onSelectItem(null)}
        dropdownData={dropdownDataToEmptyInput}
      />
    );
  }

  return nodeList.map((node, index) => {
    const RecursiveRender = () => {
      if (!node?.children?.length) {
        return;
      }

      return node.children.map((recursiveNode, childIndex) => {
        const recursiveNodesList = FormulaTree.getNodeList(recursiveNode);
        const isSeparate = childIndex !== node?.argumentsCount.length - 1 &&
          node.type === FormulaTree.NODE_TYPES.Function &&
          node?.argumentsCount.length > 1;

        return (
          <>
            <RenderNodeList
              nodeList={recursiveNodesList}
              dropdownData={dropdownData}
              setUpdateNodeCallback={setUpdateNodeCallback}
              deleteNodeCallback={deleteNodeCallback}
              setNodeCallback={setNodeCallback}
            />
            {isSeparate && <div>,</div>}
          </>
        );
      });
    };

    if (index === nodeList.length - 1) {
      return (
        <>
          <NodeRender
            node={node}
            onUpdateItem={onUpdateItem}
            onDeleteItem={onDeleteItem}
            autoActiveInputs={autoActiveInputs}
            RecursiveRenderComponent={RecursiveRender()}
            onSelectItem={onSelectItem}
            dropdownData={dropdownData}
            withEndInput={true}
          />
        </>
      );
    } else {
      if (
        node.type === FormulaTree.NODE_TYPES.Function ||
        node.type === FormulaTree.NODE_TYPES.Brackets
      ) {
        return (
          <>
            <NodeRender
              node={node}
              onDeleteItem={onDeleteItem}
              onUpdateItem={onUpdateItem}
              autoActiveInputs={autoActiveInputs}
              RecursiveRenderComponent={RecursiveRender()}
              onSelectItem={onSelectItem}
              dropdownData={dropdownData}
            />
          </>
        );
      }
      return <FormulaLabel onDeleteItem={onDeleteItem} onUpdateItem={onUpdateItem} node={node} />;
    }
  });
};

export default RenderNodeList;
